<div class="severity-chart">
	<div class="zk-flex zk-justify-between zk-items-center">
		<div class="zk-flex zk-gap-1">
			<span class="severity-chart__title">{{
				(type === 'LIFE_QUALITY'
					? 'CONTACT.LIFE_QUALITY_TITLE'
					: 'CONTACT.CGI_TITLE'
				) | translate
			}}</span>
			<div freud-tooltip [tooltipLabel]="tooltipLabel">
				<span class="freud-icon freud-icon-info-circle"></span>
			</div>
		</div>
		<div class="chart-pagination zk-gap-3 zk-flex">
			<span
				(click)="currentPage !== 1 && changePage('previous')"
				class="freud-icon freud-icon-chevron-left"
				[ngClass]="{ 'icon-disabled': currentPage === 1 }"
			></span>
			<span
				(click)="currentPage !== totalPages && changePage('next')"
				class="freud-icon freud-icon-chevron-right"
				[ngClass]="{ 'icon-disabled': currentPage === totalPages }"
			></span>
		</div>
	</div>
	<p-chart height="300px" type="line" [options]="chartOptions" [data]="chartData"></p-chart>
	<div class="severity-chart__empty" *ngIf="_severityResults.length === 0">
		<p class="empty-title">{{ 'CONTACT.SEVERITY_NO_DATA' | translate }}</p>
		<span class="empty-description">{{ 'CONTACT.SEVERITY_NO_DATA_DESCRIPTION' | translate }}</span>
		<freud-button (click)="goToPromptuaries.emit()">{{'CONTACT.SEVERITY_GO_TO_PRONTUARIES' | translate}}</freud-button>
	</div>
</div>